const UI_SCALE_STORAGE_KEY = 'fluveria-ui-scale';

export type UiScaleMode = 'compact' | 'normal' | 'comfortable';

function isUiScaleMode(value: string | null): value is UiScaleMode {
  return value === 'compact' || value === 'normal' || value === 'comfortable';
}

export function readStoredUiScale(): UiScaleMode {
  const stored = localStorage.getItem(UI_SCALE_STORAGE_KEY);
  return isUiScaleMode(stored) ? stored : 'normal';
}

export function applyUiScale(mode: UiScaleMode): void {
  document.documentElement.dataset.uiScale = mode;
}

export function initUiScaleControl(): void {
  const select = document.getElementById('ui-scale-select') as HTMLSelectElement | null;
  const initial = readStoredUiScale();
  applyUiScale(initial);
  if (!select) return;

  select.value = initial;
  select.addEventListener('change', event => {
    const next = (event.target as HTMLSelectElement).value;
    if (!isUiScaleMode(next)) return;
    localStorage.setItem(UI_SCALE_STORAGE_KEY, next);
    applyUiScale(next);
  });
}
